import { AnyMindValueType } from '@/common/graphql';

export const anyMindValuesData = {
  [AnyMindValueType.BeOpen]:
    "Embrace diversity, and express your thoughts openly while respecting other people's opinions.",
  [AnyMindValueType.BeBold]: "Don't set limitations for yourself, keep on challenging for more.",
  [AnyMindValueType.MoveFaster]: 'Be faster than anyone else, and put your ideas into action quickly.',
  [AnyMindValueType.StayUpdated]:
    'Update yourself with information, and use it to achieve better decision-making and outcomes.',
  [AnyMindValueType.AchieveTogether]: 'In all situations, always identify and run towards a common goal.',
};
